import { Routes, Route } from "react-router-dom";
import NavigationBar from "./components/generic/NavigationBar";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Products from "./pages/Products";
import Contactus from "./pages/Contactus";
// import ResourcePage from "./pages/Resources";
import Blogs from "./pages/Blogs";
import BlogDetails from "./components/blogs/BlogDetails";
import Footer from "./components/generic/Footer";
import PrivacyPolicy from "./components/generic/PrivacyPolicy";
import Ourwork from "./pages/Ourwork";
import ToastMessage from "./components/generic/ToastMessage";
import StickySocialLinks from "./components/generic/StickySocialLinks";
import PageTracker from "./components/generic/PageTracker";

const App = () => {
  return (
    <>
      <PageTracker />
      <NavigationBar />
      <StickySocialLinks />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/ourwork" element={<Ourwork />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Products />} />
        {/* <Route path="/resources" element={<ResourcePage />} /> */}
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:slug" element={<BlogDetails />} />
        <Route path="/contactus" element={<Contactus />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>

      <ToastMessage />
      <Footer />
    </>
  );
};

export default App;
